<template>
  <div class="add-composite-dialog-root">
    <el-dialog
      :visible.sync="dialogVisible"
      width="560px"
      top="20vh"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="新建组合大屏"
      :append-to-body="false"
      :before-close="handleClose">
      <div class="dialog-inner">
        <div class="intro-card" role="note">
          <span class="intro-card__tag">组合</span>
          <p class="intro-card__text">
            创建后可在画布中配置多个子大屏，通过标签栏切换展示；适合多业务看板统一入口。
          </p>
        </div>
        <el-form ref="form" :model="form" :rules="rules" class="form" @submit.native.prevent="handleSubmit">
          <el-form-item label="大屏名称" prop="panelName">
            <el-input
              v-model="form.panelName"
              class="screen-name-input"
              :maxlength="10"
              show-word-limit
              placeholder="例如：运营总览组合屏" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer-slot">
        <el-button class="footer-btn footer-btn--plain" @click="handleClose">取消</el-button>
        <el-button type="primary" class="footer-btn" :loading="btnLoading" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { saveScreenApi } from '../fetch'
import { createEmptyCompositeScreenPayload } from '@/utils/compositeScreen'

export default {
  name: 'AddCompositeScreenDialog',
  data () {
    return {
      dialogVisible: true,
      btnLoading: false,
      form: {
        panelName: '',
      },
      rules: {
        panelName: [
          { required: true, message: '请输入大屏名称', trigger: ['change', 'blur'] },
        ],
      },
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
      this.$emit('close')
    },
    async handleSubmit () {
      try {
        await this.$refs.form.validate()
        this.btnLoading = true
        const params = createEmptyCompositeScreenPayload()
        params.panelName = this.form.panelName
        const panelInfo = await saveScreenApi(params)
        this.$success('操作成功')
        this.dialogVisible = false
        this.$router.push({
          path: `/screen/edit/${panelInfo.panelSn}`,
        })
      } catch (e) {
        this.$error(e)
      } finally {
        this.btnLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.add-composite-dialog-root {
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }

  ::v-deep .el-dialog {
    margin: auto !important;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(28, 28, 28, 0.12), 0 0 1px rgba(28, 28, 28, 0.08);

    .el-dialog__header {
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #e8e8e8;
      padding: 0 40px 0 30px !important;
      color: #1c1c1c;
      background: linear-gradient(180deg, #fafbfd 0%, #fff 100%);

      .el-dialog__title {
        font-size: 17px;
        font-weight: 600;
        letter-spacing: 0.02em;
      }

      .el-dialog__headerbtn {
        width: 28px;
        height: 28px;
        top: 16px;
        right: 20px;
        background: #eef0f3;
        border-radius: 50%;
        transition: background 0.2s ease, transform 0.2s ease;

        &:hover {
          background: #e2e6eb;
          transform: scale(1.05);
        }

        .el-dialog__close {
          color: #606266;
          font-weight: bold;
        }
      }
    }

    .el-dialog__body {
      padding: 28px 30px 8px !important;
      background: #fff;
    }

    .el-dialog__footer {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 12px;
      padding: 8px 30px 36px !important;
      border-top: none;
    }
  }

  .dialog-inner {
    width: 100%;
    max-width: 440px;
    margin: 0 auto;
  }

  .intro-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    margin-bottom: 28px;
    border-radius: 8px;
    border: 1px solid #e4eafd;
    background: linear-gradient(135deg, #f4f7ff 0%, #fafbff 55%, #fff 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
  }

  .intro-card__tag {
    flex-shrink: 0;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.5;
    color: #3269ff;
    background: rgba(50, 105, 255, 0.1);
    border-radius: 4px;
    letter-spacing: 0.06em;
  }

  .intro-card__text {
    margin: 0;
    font-size: 13px;
    line-height: 1.65;
    color: #5c6370;
  }

  .form {
    width: 100%;
  }

  ::v-deep .form {
    .screen-name-input {
      width: 100%;
    }

    .el-form-item {
      margin-bottom: 8px;
    }

    .el-form-item__label {
      color: #1c1c1c;
      font-weight: 500;
      padding-right: 16px;
    }

    .el-input__inner {
      height: 46px;
      border-radius: 6px;
      transition: border-color 0.2s ease, box-shadow 0.2s ease;

      &:focus {
        box-shadow: 0 0 0 2px rgba(50, 105, 255, 0.12);
      }
    }
  }

  .dialog-footer-slot {
    display: inline-flex;
    align-items: center;
    gap: 12px;
  }

  .footer-btn {
    min-width: 104px;
    height: 40px;
    padding: 0 20px;
    border-radius: 6px;
    font-weight: 500;
  }

  .footer-btn--plain {
    border-color: #dcdfe6;
    color: #606266;

    &:hover {
      color: #3269ff;
      border-color: #c6d4ff;
      background: #f7f9ff;
    }
  }
}
</style>
